import React, { useState } from 'react';
import './SeasonalContact.css';
import CFClogo from './media/Chelsea_FC.gif';

function MatchdayHospitality() {
  const [formData, setFormData] = useState({
    title: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    postcode: '',
    companyName: '',
    numberOfGuests: '',
    fixture: '',
    query: '',
    marketingPreferences: [],
    marketingOptIn: '',
    experience: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checked2, setChecked2] = useState(false);

  // Get trackingId from URL
  const urlParams = new URLSearchParams(window.location.search);
    const trackingId = urlParams.get('trackingid') || 'MBMPaidSocial';

  const countryMapping = {
    "UNITED KINGDOM": 255340000,
    "UNITED STATES": 255340225,
    "AFGHANISTAN": 255340001,
    "ALBANIA": 255340002,
    "ALGERIA": 255340003,
    "AMERICAN SAMOA": 255340004,
    "ANDORRA": 255340005,
    "ANGOLA": 255340006,
    "ANGUILLA": 255340007,
    "ANTARCTICA": 255340008,
    "ANTIGUA AND BARBUDA": 255340009,
    "ARGENTINA": 255340010,
    "ARMENIA": 255340011,
    "ARUBA": 255340012,
    "AUSTRALIA": 255340013,
    "AUSTRIA": 255340014,
    "AZERBAIJAN": 255340015,
    "BAHAMAS": 255340016,
    "BAHRAIN": 255340017,
    "BANGLADESH": 255340018,
    "BARBADOS": 255340019,
    "BELARUS": 255340020,
    "BELGIUM": 255340021,
    "BELIZE": 255340022,
    "BENIN": 255340023,
    "BERMUDA": 255340024,
    "BHUTAN": 255340025,
    "BOLIVIA": 255340026,
    "BOSNIA AND HERZEGOWINA": 255340027,
    "BOTSWANA": 255340028,
    "BOUVET ISLAND": 255340029,
    "BRAZIL": 255340030,
    "BRITISH INDIAN OCEAN TERRITORY": 255340031,
    "BRITISH VIRGIN ISLANDS": 255340032,
    "BRUNEI DARUSSALAM": 255340033,
    "BULGARIA": 255340034,
    "BURKINA FASO": 255340035,
    "BURUNDI": 255340036,
    "CAMBODIA": 255340037,
    "CAMEROON": 255340038,
    "CANADA": 255340039,
    "CAPE VERDE": 255340040,
    "CAYMAN ISLANDS": 255340041,
    "CENTRAL AFRICAN REPUBLIC": 255340042,
    "CHAD": 255340043,
    "CHILE": 255340044,
    "CHINA": 255340045,
    "CHRISTMAS ISLAND": 255340046,
    "COCOS KEELING ISLANDS": 255340047,
    "COLOMBIA": 255340048,
    "COMOROS": 255340049,
    "CONGO": 255340050,
    "COOK ISLANDS": 255340051,
    "COSTA RICA": 255340052,
    "COTE D'IVOIRE": 255340053,
    "CROATIA": 255340054,
    "CUBA": 255340055,
    "CYPRUS": 255340056,
    "CZECH REPUBLIC": 255340057,
    "DENMARK": 255340058,
    "DJIBOUTI": 255340059,
    "DOMINICA": 255340060,
    "DOMINICAN REPUBLIC": 255340061,
    "EAST TIMOR": 255340062,
    "ECUADOR": 255340063,
    "EGYPT": 255340064,
    "EL SALVADOR": 255340065,
    "EQUATORIAL GUINEA": 255340066,
    "ERITREA": 255340067,
    "ESTONIA": 255340068,
    "ETHIOPIA": 255340069,
    "FAROE ISLANDS": 255340070,
    "FIJI": 255340071,
    "FINLAND": 255340072,
    "FRANCE": 255340073,
    "FRENCH GUIANA": 255340074,
    "FRENCH POLYNESIA": 255340075,
    "FRENCH SOUTHERN TERRITORIES": 255340076,
    "GABON": 255340077,
    "GAMBIA": 255340078,
    "GEORGIA": 255340079,
    "GERMANY": 255340080,
    "GHANA": 255340081,
    "GIBRALTAR": 255340082,
    "GREECE": 255340083,
    "GREENLAND": 255340084,
    "GRENADA": 255340085,
    "GUADELOUPE": 255340086,
    "GUAM": 255340087,
    "GUATEMALA": 255340088,
    "GUINEA": 255340089,
    "GUINEA-BISSAU": 255340090,
    "GUYANA": 255340091,
    "HAITI": 255340092,
    "HEARD AND MCDONALD ISLANDS": 255340093,
    "HONDURAS": 255340094,
    "HONG KONG - SAR OF CHINA": 255340095,
    "HUNGARY": 255340096,
    "ICELAND": 255340097,
    "INDIA": 255340098,
    "INDONESIA": 255340099,
    "IRAN": 255340100,
    "IRAQ": 255340101,
    "IRELAND": 255340102,
    "ISRAEL": 255340103,
    "ITALY": 255340104,
    "JAMAICA": 255340105,
    "JAPAN": 255340106,
    "JORDAN": 255340107,
    "KAZAKHSTAN": 255340108,
    "KENYA": 255340109,
    "KIRIBATI": 255340110,
    "KUWAIT": 255340111,
    "KYRGYZSTAN": 255340112,
    "LAO": 255340113,
    "LATVIA": 255340114,
    "LEBANON": 255340115,
    "LESOTHO": 255340116,
    "LIBERIA": 255340117,
    "LIBYAN ARAB JAMAHIRIYA": 255340118,
    "LIECHTENSTEIN": 255340119,
    "LITHUANIA": 255340120,
    "LUXEMBOURG": 255340121,
    "MACAU - SAR OF CHINA": 255340122,
    "MACEDONIA": 255340123,
    "MADAGASCAR": 255340124,
    "MALAWI": 255340125,
    "MALAYSIA": 255340126,
    "MALDIVES": 255340127,
    "MALI": 255340128,
    "MALTA": 255340129,
    "MARSHALL ISLANDS": 255340130,
    "MARTINIQUE": 255340131,
    "MAURITANIA": 255340132,
    "MAURITIUS": 255340133,
    "MAYOTTE": 255340134,
    "METROPOLITAN FRANCE": 255340135,
    "MEXICO": 255340136,
    "MICRONESIA": 255340137,
    "MOLDOVA": 255340138,
    "MONACO": 255340139,
    "MONGOLIA": 255340140,
    "MONTSERRAT": 255340141,
    "MOROCCO": 255340142,
    "MOZAMBIQUE": 255340143,
    "MYANMAR": 255340144,
    "NAMIBIA": 255340145,
    "NAURU": 255340146,
    "NEPAL": 255340147,
    "NETHERLANDS": 255340148,
    "NETHERLANDS ANTILLES": 255340149,
    "NEW CALEDONIA": 255340150,
    "NEW ZEALAND": 255340151,
    "NICARAGUA": 255340152,
    "NIGER": 255340153,
    "NIGERIA": 255340154,
    "NIUE": 255340155,
    "NORFOLK ISLAND": 255340156,
    "NORTH KOREA": 255340157,
    "NORTHERN MARIANA ISLANDS": 255340158,
    "NORWAY": 255340159,
    "OMAN": 255340160,
    "PAKISTAN": 255340161,
    "PALAU": 255340162,
    "PANAMA": 255340163,
    "PAPUA NEW GUINEA": 255340164,
    "PARAGUAY": 255340165,
    "PERU": 255340166,
    "PHILIPPINES": 255340167,
    "PITCAIRN": 255340168,
    "POLAND": 255340169,
    "PORTUGAL": 255340170,
    "PUERTO RICO": 255340171,
    "QATAR": 255340172,
    "REUNION": 255340173,
    "ROMANIA": 255340174,
    "RUSSIA": 255340175,
    "RWANDA": 255340176,
    "SAINT KITTS AND NEVIS": 255340177,
    "SAINT LUCIA": 255340178,
    "SAINT VINCENT AND THE GRENADINES": 255340179,
    "SAMOA": 255340180,
    "SAN MARINO": 255340181,
    "SAO TOME AND PRINCIPE": 255340182,
    "SAUDI ARABIA": 255340183,
    "SENEGAL": 255340184,
    "SERBIA": 255340185,
    "SEYCHELLES": 255340186,
    "SIERRA LEONE": 255340187,
    "SINGAPORE": 255340188,
    "SLOVAKIA": 255340189,
    "SLOVENIA": 255340190,
    "SOLOMON ISLANDS": 255340191,
    "SOMALIA": 255340192,
    "SOUTH AFRICA": 255340193,
    "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": 255340194,
    "SOUTH KOREA": 255340195,
    "SPAIN": 255340196,
    "SRI LANKA": 255340197,
    "ST HELENA": 255340198,
    "ST PIERRE AND MIQUELON": 255340199,
    "SUDAN": 255340200,
    "SURINAME": 255340201,
    "SVALBARD AND JAN MAYEN ISLANDS": 255340202,
    "SWAZILAND": 255340203,
    "SWEDEN": 255340204,
    "SWITZERLAND": 255340205,
    "SYRIAN ARAB REPUBLIC": 255340206,
    "TAIWAN": 255340207,
    "TAJIKISTAN": 255340208,
    "TANZANIA": 255340209,
    "THAILAND": 255340210,
    "THE DEMOCRATIC REPUBLIC OF CONGO": 255340211,
    "THE FALKLAND ISLANDS": 255340212,
    "TOGO": 255340213,
    "TOKELAU": 255340214,
    "TONGA": 255340215,
    "TRINIDAD AND TOBAGO": 255340216,
    "TUNISIA": 255340217,
    "TURKEY": 255340218,
    "TURKMENISTAN": 255340219,
    "TURKS AND CAICOS ISLANDS": 255340220,
    "TUVALU": 255340221,
    "UGANDA": 255340222,
    "UKRAINE": 255340223,
    "UNITED ARAB EMIRATES": 255340224,
    "UNITED STATES MINOR OUTLYING ISLANDS": 255340226,
    "URUGUAY": 255340227,
    "US VIRGIN ISLANDS": 255340228,
    "UZBEKISTAN": 255340229,
    "VANUATU": 255340230,
    "VATICAN CITY": 255340231,
    "VENEZUELA": 255340232,
    "VIET NAM": 255340233,
    "WALLIS AND FUTUNA ISLANDS": 255340234,
    "WESTERN SAHARA": 255340235,
    "YEMEN": 255340236,
    "ZAMBIA": 255340237,
    "ZIMBABWE": 255340238,
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      let newPrefs = [...formData.marketingPreferences];
      if (checked) {
        newPrefs.push(value);
      } else {
        newPrefs = newPrefs.filter((v) => v !== value);
      }
      setFormData({ ...formData, marketingPreferences: newPrefs });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCheckboxChange = () => {
    setChecked2(!checked2);
    setFormData({ ...formData, marketingOptIn: (checked2).toString() });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (isSubmitting) return;
    setIsSubmitting(true);
    // Validate required fields
    const requiredFields = ['firstName', 'lastName', 'phone', 'email', 'address', 'city', 'postcode', 'numberOfGuests'];
    for (let field of requiredFields) {
      if (!formData[field]) {
        setError('Please fill in all required fields.');
        setIsSubmitting(false);
        return;
      }
    }
    // const countryCode = countryMapping[formData.country.toUpperCase()] || null;
    const payload = {
      ...formData,
      trackingId,
    };
    try {
      const response = await fetch('https://prod-02.uksouth.logic.azure.com:443/workflows/fc3f999ccbbc473cb118b238bed0678b/triggers/When_Hospitality_Form_is_Submitted/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_Hospitality_Form_is_Submitted%2Frun&sv=1.0&sig=QBnUmFLtYk4GdiFaCSsV2RvHXYiEoYX_fYP2giX1S0s', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setIsSubmitted(true);
      } else {
        setError('Submission failed. Please try again.');
        setIsSubmitting(false);
      }
    } catch (err) {
      setError('Submission failed. Please try again.');
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="seasonal-contact-success">
        <h2>Thank you for your enquiry.</h2>
        <p>One of our hospitality team will contact you shortly.</p>
        <p>Chelsea Football Club</p>
      </div>
    );
  }

  return (
    <div className="container">
    <div className="seasonal-contact-header1">
        <div className="header1-inner">.
            <a className="headerlink-white" href="https://www.chelseafc.com">CHELSEA FC</a>
            <a className="headerlink-blue" href="https://www.hospitality.chelseafc.com">HOSPITALITY</a>
        </div>
        .
    </div>
    <div className="seasonal-contact-header2">
        <div className="header2-inner">.
                  <img src={CFClogo} alt="Chelsea FC Logo" className="logo-image" />
        <a className="header2-text" href="https://hospitality.chelseafc.com/upcoming-events">UPCOMING FIXTURES</a>
        <a className="header2-text" href="https://hospitality.chelseafc.com/match-by-match-hospitality-packages">MATCH BY MATCH HOSPITALITY PACKAGES</a>
        <a className="header2-text" href="https://hospitality.chelseafc.com/seasonal-packages">SEASONAL PACKAGES</a>
        <a className="header2-text" href="https://hospitality.chelseafc.com/contact-us">CONTACT US</a>
        </div>
    </div>
    <div className="seasonal-contact-parent">
    <h1>2026/27 Matchday Hospitality Enquiry Form</h1>
    <div className="seasonal-contact-flex">
      <div className="seasonal-contact-container">
        <form className="seasonal-contact-form" onSubmit={handleSubmit}>
         <h2>Please complete the form below and a member of the Club Chelsea team will be in touch.</h2>
          <div className="form-row">
            <div className="form-group">
              <label>FIRST NAME*</label>
              <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="First Name" />
            </div>
            <div className="form-group">
              <label>LAST NAME *</label>
              <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Last Name" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>PHONE NUMBER *</label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="Phone Number" />
            </div>
            <div className="form-group">
              <label>EMAIL *</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>ADDRESS *</label>
              <textarea name="address" value={formData.address} onChange={handleChange} required rows={2} placeholder="Address" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>CITY *</label>
              <input type="text" name="city" value={formData.city} onChange={handleChange} required placeholder="City" />
            </div>
            <div className="form-group">
              <label>POSTCODE *</label>
              <input type="text" name="postcode" value={formData.postcode} onChange={handleChange} required placeholder="Postcode" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>COMPANY NAME (If applicable)</label>
              <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} placeholder="Company Name" />
            </div>
            <div className="form-group">
              <label>NUMBER OF GUESTS *</label>
              <input type="text" name="numberOfGuests" value={formData.numberOfGuests} onChange={handleChange} required placeholder="Number of Guests" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <label>Which fixture are you interested in attending?</label>
              <select name="fixture" value={formData.fixture} onChange={handleChange} required>
                <option value="">Select a fixture</option>
                <option value="Tottenham Hotspur">Tottenham Hotspur</option>
                <option value="Manchester United">Manchester United</option>
                <option value="Liverpool">Liverpool</option>
                <option value="Arsenal">Arsenal</option>
                <option value="Manchester City">Manchester City</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <label>Please select the type of matchday experience you are interested in</label>
              <select name="experience" value={formData.experience} onChange={handleChange} required>
                <option value="">Select an experience</option>
                <option value="VVIP">VVIP experiences</option>
                <option value="Seated Dining">Seated Dining</option>
                <option value="Casual Dining">Casual Dining</option>
                <option value="Premium Seat-only">Premium Seat-only</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <label>PLEASE PROVIDE ANY OTHER RELEVANT INFORMATION</label>
              <textarea name="query" value={formData.query} onChange={handleChange} rows={5} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <label>YES PLEASE KEEP ME INFORMED BY...</label>
              <div className="checkbox-group">
                {['Email', 'Post', 'Phone', 'SMS'].map((option) => (
                  <label key={option}>
                    <input
                      type="checkbox"
                      name="marketingPreferences"
                      value={option}
                      checked={formData.marketingPreferences.includes(option)}
                      onChange={handleChange}
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <div className="checkbox-group">
                <label>
                  <input type="checkbox" name="marketingOptIn" checked={checked2} onChange={handleCheckboxChange} />
                  Tick here if you would like to be contacted by Chelsea FC and its group companies with news and promotional information about Chelsea FC, its official sponsors and partners and their products and services.
                </label>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group full-width">
              <small>
                We ensure that your personal information is kept secure and safe, and we do not share it with outside companies.<br />
                Please read our <a href="https://www.chelseafc.com/en/privacy-policy" target="_blank" style={{ color: '#001489', textDecoration: 'underline' }}>Privacy Policy</a> to learn more about Chelsea FC and its group companies, how we use your information and how to update your preferences for receiving marketing communications from us.*
              </small>
            </div>
          </div>
          {error && <div className="form-error">{error}</div>}
          <div className="form-row">
            <button
              type="submit"
              className={`sd-btn--action submitButton${isSubmitting ? ' submitButton--disabled' : ''}`}
              disabled={isSubmitting}
              style={isSubmitting ? { backgroundColor: '#ccc', color: '#666', cursor: 'not-allowed' } : {}}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
      <div className="seasonal-contact-divider">
      <div className="seasonal-contact-blue-square">
        <div className="displayblock">GET IN TOUCH</div>
        <a className="blueboxdisplayblock" href="tel:0371 811 1955">0371 811 1955</a>
        <a className="blueboxdisplayblock" href="mailto:clubchelsea@chelseafc.com">clubchelsea@chelseafc.com</a>
        <span className="blueboxdisplayblock">SW6 1HS</span>
      </div>
      </div>
    </div>
    </div>
    <div className="seasonal-contact-footer1">.</div>
    <div className="seasonal-contact-footer2">.</div>
    </div>
  );
}

export default MatchdayHospitality;
